export default __webpack_public_path__ + "img/app-page/Home.96bfc93dd4681aa628d098d4f645781f.png";